import PigeonMaps from './PigeonMaps';

export default PigeonMaps;
